import type { SVGProps } from 'react'

/**
 * Icon SVG as a component
 * @params pass svg props for custom settings
 * @returns icon
 */
export function KuikIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={581} height={602} viewBox="0 0 62 38" fill="none" {...props}>
      <circle cx="13.7018" cy="12.6196" r="4.32676" fill={props?.fill ?? "#007AFF"} />
      <circle cx="47.5947" cy="12.6196" r="4.32676" fill={props?.fill ?? "#007AFF"} />
      <path d="M2.68443 18.4532C-5.24814 -3.18051 26.1209 -6.06471 26.121 11.2422H35.1346C36.2161 -5.70401 65.7825 -3.54074 58.9325 18.4532C62.8974 18.4538 62.1891 24.5824 58.9325 27.1065C49.9977 34.0294 44.4697 36.0189 34.0536 37.5635C30.9569 37.827 29.2177 37.8596 26.121 37.5635C15.2788 35.4354 9.96442 33.3579 2.68443 27.1065C-1.5282 23.0874 -0.200369 18.4532 2.68443 18.4532ZM47.5946 4.68753C43.2138 4.68755 39.6622 8.23846 39.662 12.6192C39.662 17.0001 43.2137 20.5518 47.5946 20.5518C51.9755 20.5518 55.5272 17.0001 55.5272 12.6192C55.5269 8.23845 51.9754 4.68753 47.5946 4.68753ZM13.702 4.32718C9.32118 4.32718 5.76958 7.87803 5.76939 12.2588C5.76939 16.6398 9.32107 20.1914 13.702 20.1914C18.0827 20.1911 21.6337 16.6396 21.6337 12.2588C21.6335 7.87823 18.0826 4.3275 13.702 4.32718Z" fill={props?.fill ?? "#007AFF"} />
    </svg>
  )
}
